<template lang="pug">
    .yearsTimeline(:style="{width: events.length*100+'px'}" :class="{hide:hide}")
        .item(v-for="(event, index) in events"
            data-hover
            @mouseover="openedYearIndex = index"
            @click="$router.replace('/#history_'+event.id)"
            :class="{opened: openedYearIndex===index}")
            .img(:style="{backgroundImage: 'url('+event.icon+')'}")
            .year {{event.year}}
</template>

<script>
    export default {
        name: "YearsTimeline",
        props: ['events', 'hide'],
        watch: {
            hide() {
                if (this.hide) {
                    this.openedYearIndex = null;
                }
            }
        },
        data: () => ({
            openedYearIndex: null,
        }),
    }
</script>

<style scoped lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_mixins.scss";

    .yearsTimeline {
        position: absolute;
        bottom: 6.9vh;
        left: 50%;
        transform: translateX(-50%);
        max-width: 70vw;
        min-height: 1px;
        display: flex;
        justify-content: space-between;
        background: url(../../assets/img/yearsTimeline_dotts.png) repeat-x center center;
        transition: opacity .5s;

        &.hide {
            opacity: 0;
        }
    }

    .item {
        position: relative;
        display: flex;
        justify-content: center;
        cursor: pointer;

        &:before, &:after {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 50%;
            z-index: 1;
        }

        &:before {
            width: to_rem(5px);
            height: to_rem(5px);
            background: $blue;
        }

        &:after {
            width: to_rem(14px);
            height: to_rem(14px);
            border: 1px solid $blue;
            opacity: 0;
            transition: .3s;
        }
    }

    .img {
        position: absolute;
        bottom: 2vh;
        z-index: 2;
        width: to_rem(48px);
        height: to_rem(48px);
        border-radius: 50%;
        background: no-repeat center center / cover;
        pointer-events: none;
        opacity: 0;
        transition: .3s;
    }

    .year {
        position: absolute;
        bottom: 1.2rem;
        color: $blue;
        font-size: to_rem(15px);
        transition: .3s;

        &:after {
            content: '';
            display: block;
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            background: #c7d9ea;
            width: 1px;
            height: 1.2rem;
            transition: inherit;
        }
    }

    .opened {
        .img {
            //bottom: 5.9vh;
            bottom: 3.2rem;
            opacity: 1;
            pointer-events: all;
        }

        .year {
            //bottom: 11.5vh;
            bottom: 6.35rem;
            font-size: to_rem(20px);
            font-weight: bold;

            &:after {
                //height: 10vh;
                height: 6rem;
                top: 150%;
            }
        }

        &:after {
            opacity: 1;
        }
    }
</style>
